import React from "react";

interface IndicatorIconProps {
  className?: string;
  onClick?: () => void;
}

export const IndicatorIcon = ({ className, onClick }: IndicatorIconProps) => (
  <svg
    width="47"
    height="37"
    viewBox="0 0 47 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
    className={className}
  >
    <path
      d="M6.92391 7.40181C11.4591 2.86663 16.9013 0.599041 23.2505 0.599041C29.5998 0.599041 35.0153 2.86663 39.4972 7.40181C44.0323 11.8836 46.2999 17.2992 46.2999 23.6484C46.2999 27.8101 45.2595 31.6783 43.1786 35.2531C42.6985 36.0535 41.9782 36.4536 41.0178 36.4536H5.48332C4.52293 36.4536 3.80264 36.0535 3.32244 35.2531C1.24159 31.6783 0.201172 27.8101 0.201172 23.6484C0.201172 17.2992 2.44208 11.8836 6.92391 7.40181ZM41.0178 33.8926C42.8318 30.7446 43.7389 27.3299 43.7389 23.6484C43.7389 17.9928 41.7381 13.1641 37.7364 9.16252C33.7348 5.1609 28.9062 3.16008 23.2505 3.16008C17.5949 3.16008 12.7663 5.1609 8.76465 9.16252C4.76303 13.1641 2.76221 17.9928 2.76221 23.6484C2.76221 27.3299 3.69593 30.7713 5.56335 33.9726L41.0178 33.8926ZM29.413 8.3622C29.5731 8.41555 29.7065 8.49558 29.8132 8.60229C29.9733 8.709 30.08 8.84239 30.1333 9.00246C30.2401 9.16252 30.2934 9.32259 30.2934 9.48265C30.2934 9.64272 30.2667 9.80278 30.2134 9.96285L26.0517 21.9677C27.599 22.9815 28.3726 24.3954 28.3726 26.2095C28.3726 27.65 27.8658 28.8772 26.852 29.891C25.8916 30.8513 24.6911 31.3315 23.2505 31.3315C21.81 31.3315 20.5828 30.8513 19.569 29.891C18.6087 28.8772 18.1285 27.65 18.1285 26.2095C18.1285 24.7689 18.6087 23.5684 19.569 22.608C20.5828 21.5942 21.81 21.0874 23.2505 21.0874C23.3039 21.0874 23.3839 21.0874 23.4906 21.0874C23.5974 21.0874 23.6507 21.114 23.6507 21.1674L27.8124 9.16252C27.9191 8.84239 28.1325 8.60229 28.4527 8.44223C28.7728 8.28216 29.0929 8.25549 29.413 8.3622ZM21.4098 28.0502C21.9433 28.5304 22.5569 28.7705 23.2505 28.7705C23.9442 28.7705 24.5311 28.5304 25.0113 28.0502C25.5448 27.5167 25.8116 26.9031 25.8116 26.2095C25.8116 25.5158 25.5448 24.9289 25.0113 24.4487C24.5311 23.9152 23.9442 23.6484 23.2505 23.6484C22.5569 23.6484 21.9433 23.9152 21.4098 24.4487C20.9296 24.9289 20.6895 25.5158 20.6895 26.2095C20.6895 26.9031 20.9296 27.5167 21.4098 28.0502Z"
      fill="#4187B6"
    />
  </svg>
);

IndicatorIcon.defaultProps = {
  className: "",
  onClick: undefined,
};
